export default "__VITE_ASSET__pR_NBkYG__"